import {PartialTaskForTimeParsing} from '../model';
import {
  getUTCDateTime,
  getUTCDateTimeFromMillis,
  getUTCDateTimeFromString,
} from './getUTCDateTime';

export const getDateFromIso = (dateTime: string): string =>
  dateTime.split('T')[0];

export const getTimeFromIso = (dateTime: string): string =>
  dateTime.split('T')[1];

export const getIsoDateFromDateAndTime = (date: string, time: string): string =>
  getUTCDateTimeFromString(`${date}T${time}`).toISO();

export const isTaskInRangeOfCurrentWorkingDay = (
  task: PartialTaskForTimeParsing,
  shiftHourStart: number
): boolean => {
  const {shiftStartTimeMillis, shiftEndTimeMillis, shiftStartDate} =
    getStartDateAndEndDateForWorkingDay(shiftHourStart);
  return isTaskInRange(
    task,
    shiftStartTimeMillis,
    shiftEndTimeMillis,
    shiftStartDate
  );
};

export const isTaskInRange = (
  task: PartialTaskForTimeParsing,
  shiftStartTimeMillis: number,
  shiftEndTimeMillis: number,
  shiftStartDate: string
): boolean => {
  const taskDate = task.date;
  const taskTime = task.completeUntil?.time;
  if (taskTime) {
    const taskTimeMillis = getUTCDateTimeFromString(
      `${taskDate}T${taskTime}`
    ).toMillis();
    return isTaskBetweenMillisForShiftTimestamp(
      taskTimeMillis,
      shiftStartTimeMillis,
      shiftEndTimeMillis
    );
  }
  return isDayForCurrentShift(shiftStartDate, taskDate);
};

export const isDayForCurrentShift = (
  shiftStartDate: string,
  taskDate?: string | null
): boolean => !!taskDate && taskDate === shiftStartDate;

export const isTaskBetweenMillisForShiftTimestamp = (
  taskTimeMillis: number,
  shiftStartTimeMillis: number,
  shiftEndTimeMillis: number
): boolean =>
  taskTimeMillis >= shiftStartTimeMillis &&
  taskTimeMillis <= shiftEndTimeMillis;

export const isTaskBeforeMillisForShiftTimestampEnd = (
  taskTimeMillis: number,
  shiftEndTimeMillis: number
): boolean => taskTimeMillis <= shiftEndTimeMillis;

export const getStartDateAndEndDateForWorkingDay = (shiftHour: number) => {
  const shiftHourString = 10 > shiftHour ? `0${shiftHour}` : String(shiftHour);
  const nowUTCHour = getCurrentUTCHour();
  let shiftStartTimeIso: string;

  if (nowUTCHour >= shiftHour!) {
    // today's shift
    const todayDate = getDateFromIso(getUTCDateTime().toISO());
    shiftStartTimeIso = `${todayDate}T${shiftHourString}:00:00.000Z`;
  } else {
    // yesterday's shift
    const yesterDate = getUTCDateTime().minus({day: 1}).toISODate();
    shiftStartTimeIso = `${yesterDate}T${shiftHourString}:00:00.000Z`;
  }

  const shiftEndTimeMillis = getUTCDateTimeFromString(shiftStartTimeIso)
    .plus({day: 1})
    .minus({millisecond: 1})
    .toMillis();
  const shiftStartDate = getDateFromIso(shiftStartTimeIso);

  const shiftEndDate = getDateFromIso(
    getUTCDateTimeFromMillis(shiftEndTimeMillis).toISO()
  );
  const shiftStartTimeMillis =
    getUTCDateTimeFromString(shiftStartTimeIso).toMillis();

  return {
    shiftStartDate,
    shiftStartTimeMillis,
    shiftEndDate,
    shiftEndTimeMillis,
  };
};

export const getCurrentUTCHour = () => getUTCDateTime().hour;
